import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllContracts(_obj, params) {
    const res = await axios.get('api/contracts/', { params });
    return res.data;
  },
  async getContract(_obj, id) {
    const res = await axios.get(`api/contracts/${id}/`);
    return res.data;
  },
  async createContract(_obj, data) {
    return axios.post('api/contracts/', data);
  },
  async updateContract(_obj, { id, data }) {
    return axios.patch(`api/contracts/${id}/`, data);
  },
  async deleteContract(_obj, id) {
    return axios.delete(`api/contracts/${id}/`);
  },
  async sendContract(_obj, id) {
    return axios.post(`api/contracts/${id}/send/`);
  },
  async voidContract(_obj, id) {
    return axios.post(`api/contracts/${id}/void/`);
  },
  async getContractAudit(_obj, id) {
    const res = await axios.get(`api/contracts/${id}/audit/`);
    return res.data;
  },
  async getContractPdf(_obj, id) {
    const res = await axios.get(`api/contracts/${id}/pdf/`);
    return res.data;
  },
  // Public signing endpoints (no auth)
  async getSigningContract(_obj, token) {
    const res = await axios.get(`api/contracts/sign/${token}/`);
    return res.data;
  },
  async submitSignature(_obj, { token, data }) {
    return axios.post(`api/contracts/sign/${token}/`, data);
  },
};

export const contract = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
